import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useBonuses } from '@/api';
import type { BonusTransaction } from '@/domain/bonuses';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { BonusesPanel } from '@/ui/profile';

export const Route = createFileRoute('/profile/bonuses/')({
  component: ProfileBonusesPage,
});

export function ProfileBonusesPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const navigate = useNavigate();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const bonuses = useBonuses(true);

  const onSelectBonus = (bonus: BonusTransaction) => {
    void navigate({
      to: '/profile/bonuses/$bonusType/$bonusId',
      params: {
        bonusType: String(bonus.Type),
        bonusId: bonus.Id,
      },
    });
  };

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('Bonuses', 'Bonuses')}
        </h1>
        <p className="text-[13px] text-text-secondary">
          {label(
            'Track active offers and wagering progress.',
            'Track active offers and wagering progress.',
          )}
        </p>
      </header>
      <BonusesPanel bonuses={bonuses} onSelectBonus={onSelectBonus} />
    </div>
  );
}
